import { createUseStyles } from 'react-jss';

import { theme } from '@align-cpf/uikit-styles';

const { colors, spacing } = theme;

export default createUseStyles<string, { maxHeight?: string }>(
  {
    root: {
      position: 'fixed',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: -1,
      backgroundColor: colors.backgroundOverlay,
      boxSizing: 'border-box',
      pointerEvents: 'unset',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },

    isOpen: {
      zIndex: 1000,
      pointerEvents: 'visible',
    },

    header: {
      display: 'flex',
      flexBasis: '100%',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: [0, spacing.sp05],
    },

    footer: {
      display: 'flex',
      justifyContent: 'flex-end',
      flexGrow: 0,
      flexShrink: 0,
      padding: [spacing.sp02, spacing.sp05, 0],
    },

    closeIcon: {
      alignSelf: 'flex-start',
      cursor: 'pointer',
      color: colors.iconPrimary,
    },

    withHeader: {
      justifyContent: 'space-between',
    },

    modal: {
      position: 'absolute',
      display: 'flex',
      flexDirection: 'column',
      maxHeight: `calc(100vh - ${spacing.sp05})`,
      width: '90%',
      padding: [spacing.sp05, 0],
      border: [1, 'solid', colors.borderSubtle],
      borderRadius: spacing.sp01,
      boxSizing: 'border-box',
      backgroundColor: 'white',
      overflow: 'hidden',
    },

    content: {
      padding: [0, spacing.sp05],
      overflowY: 'auto',
      overflowX: 'clip',
    },
  },

  {
    name: 'Modal',
  },
);
